import styled from '@emotion/styled'
import {cssTheme} from '@vio/atlas/themes'

export const BackButtonWrapper = styled('div')`
  padding: ${cssTheme.layout.spacing.s400} 0 0 ${cssTheme.layout.spacing.s500};
`
